import { render, staticRenderFns } from "./SocialUserModalAlterarUsuario.vue?vue&type=template&id=2530e87c"
import script from "./SocialUserModalAlterarUsuario.vue?vue&type=script&lang=js"
export * from "./SocialUserModalAlterarUsuario.vue?vue&type=script&lang=js"
import style0 from "./SocialUserModalAlterarUsuario.vue?vue&type=style&index=0&id=2530e87c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2530e87c')) {
      api.createRecord('2530e87c', component.options)
    } else {
      api.reload('2530e87c', component.options)
    }
    module.hot.accept("./SocialUserModalAlterarUsuario.vue?vue&type=template&id=2530e87c", function () {
      api.rerender('2530e87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SocialUserModalAlterarUsuario.vue"
export default component.exports